import React, { useEffect, useState, useCallback } from "react";
import SubNav from "../../../Shared/SubNav";
import { useLocation, useNavigate } from "react-router-dom";
import _ from "lodash";
import socket from "../../../context/socket";
import axios from "axios";
import Swal from "sweetalert2";
import { useDispatch, useSelector } from "react-redux";
import { fetchAdvisorData } from "../../../redux/advisor/advisorSlice";
import { fetchClientData } from "../../../redux/client/clientSlice";
import api from "../../../utils/api";

const RiskReward = () => {
  const [selectedCards, setSelectedCards] = useState([]);
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const roomId = new URLSearchParams(location.search).get("clientId");
  const [riskReward, setRiskReward] = useState();
  const [isError, SetError] = useState("");
  const { clientData } = useSelector((state) => state.client);

  console.log("riskReward", riskReward);

  // For getting Card Data
  useEffect(() => {
    api
      .get(
        `advisor/get_inbelief_section/second`
      )
      .then((response) => {
        const data = response.data;
        console.log("Message Received:", data);
        dispatch(fetchClientData(roomId));

        setRiskReward(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }, [roomId]);


  // Fetch previously selected cards
  useEffect(() => {
    if (clientData?.risk_reward_in_investing) {
      setSelectedCards(clientData.risk_reward_in_investing);

    }
  }, [clientData]);

  useEffect(() => {
    socket.emit("join", roomId);
  }, [roomId]);

  // Debounced function to emit messages
  const debouncedEmitMessage = useCallback(
    _.debounce(() => {
      socket.emit("message", { room: roomId, data: { selectedCards } });
    }, 300),
    [selectedCards]
  );

  useEffect(() => {
    debouncedEmitMessage();
  }, [selectedCards, debouncedEmitMessage]);

  // console.log("selectedCards", selectedCards);


  const handleNext = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");

    const nextUrl = "/long-term-investing?clientId=" + roomId;
    const nextUrl2 = "/long-term-investing";

    const allSectionIds = riskReward.section.map((section) => section._id);
    const selectedCardIds = selectedCards.map((card) => card._id);
    const allSelected = allSectionIds.every((id) =>
      selectedCardIds.includes(id)
    );
    if (!allSelected) {
      Swal.fire({
        icon: 'warning',
        title: 'Warning',
        text: 'Please Prioritize all Beliefs!',
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'swal-confirm-btn  ',
        },
      });
      return;
    }


      // Deep compare priorities and order
      const original = clientData?.risk_reward_in_investing || [];
      const updated = selectedCards;
    
      const isSame = original.length === updated.length &&
        original.every((item, index) =>
          item._id === updated[index]._id && item.priority === updated[index].priority
        );

    const allData = {
      _id: roomId,
      riskRewardInInvesting: selectedCards,
    };
    api
      .post(
       "advisor/riskRewardInInvesting",
        allData
      )
      .then((response) => {
        if (!isSame) {
          sendAggredStatus(); // Only call if changed
        }
        socket.emit("navigate", { room: roomId, url: nextUrl2 });
        navigate(nextUrl); // Navigate to the next page in the advisor app
      })
      .catch((error) => {
        console.error("Error saving message:", error);
      });

    socket.emit("navigate", { room: roomId, url: nextUrl2 });
    navigate(nextUrl);
  };

  const sendAggredStatus = async () => {
    try {
      // Get current date and time
      const currentDateTime = new Date().toISOString();
  
      // Get system IP (client-side using an IP API)
      // const ipResponse = await api.get("https://api.ipify.org?format=json");
      // const currentIP = ipResponse.data.ip;

      const res = await fetch("https://www.finedge.in/home/getRemoteHeaders");
      const data = await res.json()
      console.log('response',data?.ip);

      // const currentIP = '111.111.1.11';

  
      // Send data to backend
      const response = await api.post(
       "advisor/set_inbelief_agreed",
        {
          _id: roomId,
          inv_belief_agreed: 'no',
          inv_belief_agreed_date: currentDateTime,
          inv_belief_agreed_IP: data?.ip,
        }
      );
  
      // dispatch(fetchClientData(roomId));
      // console.log("sendAggredStatus", response);
    } catch (error) {
      console.log("Some Errors", error);
    }
  };

  const handleBack = () => {
    const roomId = new URLSearchParams(window.location.search).get("clientId");


    const prevUrl = "/priorities?clientId=" + roomId;
    const prevUrl2 = "/priorities";

    socket.emit("navigate", { room: roomId, url: prevUrl2 });
    navigate(prevUrl);
  };

  const handleCardClick = (_id) => {
    setSelectedCards((prevSelectedCards) => {
      const isSelected = prevSelectedCards.some((card) => card._id === _id);

      if (isSelected) {
        return prevSelectedCards
          .filter((card) => card._id !== _id)
          .map((card, index) => ({ ...card, priority: index + 1 }));
      } else {
        return [
          ...prevSelectedCards,
          { _id, priority: prevSelectedCards.length + 1 },
        ];
      }
    });
  };

  const getCardStyle = (_id) => ({
    backgroundColor: selectedCards.some((card) => card._id === _id)
      ? "#23674B"
      : "white",
    // border: "2px solid green",
    cursor: "pointer",
    transition: "background-color 0.3s ease",
    boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
    minHeight: "242px"
  });

  const getCardNumber = (_id) => {
    const card = selectedCards.find((card) => card._id === _id);
    console.log('fd', card, _id, clientData?.risk_reward_in_investing);
    return card ? card.priority : "";
  };

  const getCardTextStyle = (cardId) => ({
    color: selectedCards.some((card) => card._id === cardId)
      ? "#fff"
      : "#000",
  });
  const containerStyle = {
    display: "flex",
    flexWrap: "wrap",
    gap: "1rem",
    justifyContent: "space-between",
  };

  const circleStyle = {
    height: "60px",
    width: "60px",
    borderRadius: "50%",
    // border: "2px solid green",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fdfdfd",

  };

  return (
    <>
      <div className="container minht">
        <div className="row ">
          <div className="col-md-12 col-lg-4 position-relative ">
            <div className="">
              <div>
                <h2 className=" " style={{ fontSize: "50px" }}>
                  {riskReward && riskReward.title}
                </h2>
                <p className="fs-18">(Highest to Lowest)</p>
              </div>

            </div>
          </div>

          <div className="col ">
            <div className="row">
              {riskReward &&
                riskReward.section.map((card) => (
                  <div key={card._id} className="col-lg-6 ">
                    <div className="card border-1 my-3 mb-md-3 investingBeliefCard" style={{ width: '396px!important', height: '274px' }} onClick={() => handleCardClick(card._id)}>
                      <div class="card-body">
                        <h5 class="card-text reward23 pb-4 investingBeliefText" style={{ width: "80%"}}>{card.title}

                        </h5>
                        <div class="border border-1  circle custom-circle  " style={{ position: "absolute", bottom: "25px" }}>
                          <h3 class="text-center lh-53 darktext" > {getCardNumber(card._id)}</h3>
                        </div>
                        <div className="d-flex justify-content-between align-items-center h-50">
                          <div></div>
                          <img
                            className="card-img-position img-fluid d-block mx-auto"
                            style={{
                              height: "150px",
                              width: "120px",
                            }}
                            src={card.icon}
                            alt={card.text}
                          />

                        </div>

                      </div>
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>

      <div className="container">
        <div className="row">
          <div className="col text-end mb-4">
            <div className="d-flex justify-content-between align-items-center">
              <p className="text-danger fw-semibold">
                {isError}
              </p>
              <div>
                <a onClick={handleBack}>
                  <img
                    className="arrow_next1"
                    src="assets/images/left-arrowpng.png"
                    alt=""
                  />
                </a>
                <a
                  href="javascript:void(0);"
                  className="ms-1"
                  onClick={handleNext}
                >
                  <img
                    className="arrow_next"
                    src="assets/images/right-arrow.svg"
                    alt=""
                  />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RiskReward;
